import { createFileRoute } from '@tanstack/react-router'
import Loading from '@/components/Loading'
import { useRedirectToLastUrl } from '@/hooks/useRedirectToLastUrl'

function Index() {
  useRedirectToLastUrl()
  return <Loading />
}

export const Route = createFileRoute('/_auth/')({
  component: Index,
})
